import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, BookOpenIcon } from 'lucide-react';
const tomos = [{
  id: 1,
  title: 'El Arquitecto',
  subtitle: 'Fundamentos y Biomecánica',
  tagline: 'La base que nadie te enseña.',
  content: 'Comprende la física detrás de cada golpe. Aprende el grip perfecto, la cadena cinética para generar un topspin sin forzar el hombro, y el efecto látigo (Whip) para máxima velocidad y spin.'
}, {
  id: 2,
  title: 'El Motor',
  subtitle: 'Sistematización y Movimiento',
  tagline: 'Sistematiza tu entrenamiento.',
  content: 'Domina el "Loop-Reset", el juego de pies de élite y aplica bloques de drills diseñados para crear memoria muscular irrompible. Se acabó el peloteo pasivo.'
}, {
  id: 3,
  title: 'El Estratega',
  subtitle: 'Optimización y Mentalidad',
  tagline: 'Gana antes de sacar.',
  content: 'La matriz de decisiones para jugar bajo presión, análisis de video para corregir tu técnica, y el plan de 30 días para pasar de intermedio a competitivo.'
}];
export function TomosSection() {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section className="py-10 sm:py-16 lg:py-24 bg-navy-800 relative" data-id="element-284">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="text-center mb-8 sm:mb-12" data-id="element-286">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display text-offwhite uppercase mb-3" data-id="element-287">
            CONTENIDO COMPLETO:{' '}
            <span className="text-gold-500" data-id="element-288">LOS 3 TOMOS</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-text-secondary" data-id="element-289">
            Tu hoja de ruta para dominar el tenis de mesa avanzado.
          </p>
          <p className="text-xs sm:text-sm text-gold-400 mt-2 sm:mt-4 animate-pulse" data-id="element-290">
            (Tocá cada módulo para ver lo que incluye 👆)
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:gap-4" data-id="element-291">
          {tomos.map(tomo => {
          const isOpen = openId === tomo.id;
          return <motion.div key={tomo.id} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-navy-900 border-gold-500/50 shadow-[0_0_20px_rgba(212,168,87,0.1)]' : 'bg-navy-900/50 border-navy-700 hover:bg-navy-900'}`} data-id="element-292">
                <button onClick={() => setOpenId(isOpen ? null : tomo.id)} className="w-full text-left px-4 py-3 sm:px-6 sm:py-5 flex items-center justify-between focus:outline-none" data-id="element-293">
                  <div className="flex items-center gap-3 sm:gap-6" data-id="element-294">
                    <div className={`font-display text-3xl sm:text-4xl md:text-5xl transition-colors ${isOpen ? 'text-gold-500' : 'text-navy-700'}`} data-id="element-295">
                      0{tomo.id}
                    </div>
                    <div data-id="element-296">
                      <h3 className="font-bold text-offwhite text-sm sm:text-lg md:text-xl flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-2 leading-tight" data-id="element-297">
                        <span data-id="element-298">
                          Tomo {tomo.id}: {tomo.title}
                        </span>
                        <span className={`text-xs sm:text-sm md:text-base font-normal transition-colors ${isOpen ? 'text-gold-400' : 'text-text-secondary'}`} data-id="element-299">
                          ({tomo.subtitle})
                        </span>
                      </h3>
                    </div>
                  </div>
                  <ChevronDownIcon className={`w-5 h-5 sm:w-6 sm:h-6 text-text-secondary transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180 text-gold-400' : ''}`} data-id="element-300" />
                </button>

                <AnimatePresence data-id="element-301">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-302">
                      <div className="px-4 pb-4 pt-1 sm:px-6 sm:pb-6 sm:pt-2 sm:pl-[88px]" data-id="element-303">
                        <div className="bg-navy-800 p-3 sm:p-4 rounded-lg border border-navy-700" data-id="element-304">
                          <p className="font-bold text-offwhite text-xs sm:text-sm md:text-base mb-1.5 sm:mb-2 flex items-center gap-1.5 sm:gap-2" data-id="element-305">
                            <BookOpenIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold-400 flex-shrink-0" data-id="element-306" />
                            {tomo.tagline}
                          </p>
                          <p className="text-text-secondary text-[11px] sm:text-sm md:text-base leading-relaxed" data-id="element-307">
                            {tomo.content}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}